import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

export const DefaultFieldView = ({ field, value, formattedValue }) => {
  const toString = (value) => {
    if (value === undefined || value === null) {
      return "";
    }
    if (typeof value === "object") {
      return JSON.stringify(value);
    }
    return value.toString();
  };

  return (
    <LabelValueForText
      label={"Not implemented: " + (field.headerName || field.name)}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={toString(formattedValue)}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    />
  );
};

export const defaultFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "string",
    valueFormatter: field.valueFormatter,
  };
};
